import React, {Component} from 'react';
import { Modal, Button, Tabs, Tab} from 'react-bootstrap';

interface ModalShareLayerProps {
    show: boolean,
    onHandleClose: Function,
    onCopyURL: Function,
    layer: any
    //widgetInstance: any
}

interface ModalShareLayerState {

}

class ModalShareLayer extends Component<ModalShareLayerProps, ModalShareLayerState> {
  constructor(props: any) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
    this.handleCopyURL = this.handleCopyURL.bind(this);
    this.makeArcGISTemplate = this.makeArcGISTemplate.bind(this);
  }

  handleClose() {
    const { onHandleClose} = this.props;
    onHandleClose();
  }

  handleCopyURL(_templateText:string) {
    navigator.clipboard.writeText(_templateText)
  }
  
  makeArcGISTemplate(_templateText:string) {
    return _templateText.replace("{z}","{level}").replace("{x}","{col}").replace("{y}","{row}")
  }

  getValidTemplate(_this:any){
    if (_this.props.layer.sourceChangeKey_){
      if (_this.props.layer.sourceChangeKey_.target){
        if (_this.props.layer.sourceChangeKey_.target.urls){
          return _this.props.layer.sourceChangeKey_.target.urls[0];
        }else{
          return false;
        }
      }else{
        return false;
      }
    }else{
      return false;
    }
  }  
  getValidCapabilities(_this:any){
    if (_this.props.layer.values_){
      if (_this.props.layer.values_.dataSourceRow){
        if (_this.props.layer.values_.dataSourceRow.capabilities){
          return _this.props.layer.values_.dataSourceRow.capabilities;
        }else{
          return false;
        }
      }else{
        return false;
      }
    }else{
      return false;
    }
  }

  render() {
    const { show } = this.props;
    return (
      <Modal
        size="lg"
        show={show}
        centered
        onHide={this.handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title>Share Layer</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/*
          <p>Copy the property</p>
          for example WTMS:  http://realearth.ssec.wisc.edu/products/j01-viirs-true-color
          X/Y/Z template:	   http://realearth.ssec.wisc.edu/tiles/j01-viirs-true-color/{z}/{x}/{y}.png
          ArcGIS template:   http://realearth.ssec.wisc.edu/tiles/j01-viirs-true-color/{level}/{col}/{row}.png
          */
          //console.log("layer object for share layer modal", this.props.layer)
          }
            <Tabs defaultActiveKey="XYZ" id="mapServiceTabs">
              { this.getValidTemplate(this)
              ? [<Tab key="XYZKey" eventKey="XYZ" title="XYZ">
                <div className="copy-service-template" onClick={() =>  this.handleCopyURL(this.getValidTemplate(this))}>
                  {this.getValidTemplate(this)}
                </div>
                <Button variant="primary" onClick={() => this.handleCopyURL(this.getValidTemplate(this))}>Copy to Clipboard</Button>
              </Tab>,
              <Tab key="ArcGISKey" eventKey="ArcGIS" title="ArcGIS">
                <div className="copy-service-template" onClick={() =>  this.handleCopyURL(this.makeArcGISTemplate(this.getValidTemplate(this)))}>
                  {this.makeArcGISTemplate(this.getValidTemplate(this))}
                </div>
                <Button variant="primary" onClick={() => this.handleCopyURL(this.makeArcGISTemplate(this.getValidTemplate(this)))}>Copy to Clipboard</Button>
              </Tab>]
              : <Tab eventKey="XYZ/ArcGIS" title="XYZ/ArcGIS">
                <div className="copy-service-template">
                    XYZ/ArcGIS tempates not available on this resource
                </div>
              </Tab>}
              {this.getValidCapabilities(this)
                ? <Tab eventKey="WMTS" title="WMTS">
                    <div className="copy-service-template" onClick={() =>  this.handleCopyURL(this.getValidCapabilities(this))}>
                      {this.getValidCapabilities(this)}
                    </div>
                    <Button variant="primary" onClick={() => this.handleCopyURL(this.getValidCapabilities(this))}>Copy to Clipboard</Button>
                  </Tab>
                : ""
                }
            </Tabs>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>Cancel</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default ModalShareLayer;
